export default __webpack_public_path__ + "static/media/background_l.2d8599b4.png";